import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { IMAGES } from "../lib/assets";

const TENETS = [
  {
    label: "Long-term",
    title: "We think in decades.",
    text: "Our horizon is generational. We are unconstrained by quarterly cycles, allowing us to invest with patience and let value compound over time.",
  },
  {
    label: "Disciplined",
    title: "Conviction over consensus.",
    text: "We pursue a narrow set of opportunities we understand deeply, and decline far more than we accept. Discipline is the foundation of endurance.",
  },
  {
    label: "Private",
    title: "Quiet by design.",
    text: "We operate privately and partner selectively. Our work is measured not in attention, but in the durability of what we build.",
  },
];

export default function Philosophy() {
  return (
    <div data-testid="philosophy-page">
      <PageHero
        testId="philosophy-hero"
        eyebrow="Philosophy"
        title={
          <>
            Permanence over
            <br />
            momentum.
          </>
        }
        intro="We believe enduring value is created slowly, deliberately, and with conviction — across generations rather than cycles."
        image={IMAGES.interior}
        alt="Minimalist luxury interior with ocean view"
      />

      {/* Intro statement */}
      <section className="bg-aveden-black py-28 lg:py-40">
        <div className="mx-auto max-w-4xl px-6 sm:px-10 text-center">
          <Reveal>
            <p className="font-sans text-[11px] tracking-[0.4em] uppercase text-aveden-gold mb-10">
              Our Belief
            </p>
          </Reveal>
          <Reveal delay={0.12}>
            <h2 className="font-serif font-light text-aveden-white text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.3] tracking-tight text-balance">
              Capital, when stewarded with patience and intention, becomes a
              quiet force for permanence — for families, for enterprises, and
              for the generations that follow.
            </h2>
          </Reveal>
        </div>
      </section>

      {/* Tenets */}
      <section className="bg-aveden-rich py-24 lg:py-32 border-t border-white/[0.05]">
        <div className="mx-auto max-w-[1400px] px-6 sm:px-10 lg:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-16 lg:gap-20">
            {TENETS.map((t, i) => (
              <Reveal key={t.label} delay={i * 0.1}>
                <div
                  data-testid={`tenet-${t.label.toLowerCase()}`}
                  className="border-t border-aveden-gold/40 pt-8"
                >
                  <p className="font-sans text-[11px] tracking-[0.32em] uppercase text-aveden-gold mb-6">
                    {t.label}
                  </p>
                  <h3 className="font-serif font-light text-aveden-white text-2xl lg:text-3xl leading-snug mb-6">
                    {t.title}
                  </h3>
                  <p className="font-sans font-light text-sm text-aveden-gray leading-relaxed">
                    {t.text}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
